export default __webpack_public_path__ + "static/media/favicon.a1bcfbe8.ico";